import { EEntities } from '@/types'
import TypeAssistant from './type-assistant'

export default new class ColorAssistant {
  public get StatusColorOptions(): string[] {
    return [
      'dodger-blue',
      'viridian',
      'algae-green',
      'bluish-grey',
      'bluey-purple',
      'strawberry',
      'darkish-pink',
      'reddish-orange',
      'light-orange',
    ]
  }

  public get DefaultStatusColorOptions(): string {
    return this.StatusColorOptions[0]
  }

  public getEntityColor(entityType: EEntities): string {
    switch (entityType) {
      case EEntities.MAILBOXES:
        return 'green'
      case EEntities.PROJECTS:
        return 'blue'
      default:
        return ''
    }
  }

  public getEntityColorByEntityTypeID(entityTypeID: number): string {
    return this.getEntityColor(TypeAssistant.getEntityType(entityTypeID))
  }

  public get ProjectColor(): string {
    return this.getEntityColor(EEntities.PROJECTS)
  }

  public get MailboxColor(): string {
    return this.getEntityColor(EEntities.MAILBOXES)
  }

  public get PeopleColor(): string {
    return 'dark-teal'
  }
}()
